import get from 'lodash/get';
import pick from 'lodash/pick';

import { COUPON_FLOW } from 'src/common/constants/subscription/flow';
import { COUPON_PATH } from 'src/common/constants/paths';
import parseQuery from '../../utils/queryString/parse';
import hasActiveSubscription from './hasActiveSubscription';

export default function getCouponRedirect(me, location) {
  const hasActiveSub = hasActiveSubscription(me);
  const query = parseQuery(get(location, 'search', ''));
  const inCouponSubFlow = query[COUPON_FLOW];

  if (hasActiveSub && inCouponSubFlow) {
    return {
      pathname: COUPON_PATH,
      query: pick(query, 'source'),
    };
  }

  return undefined;
}
